import {AdminPagingModel} from "./AdminPagingModel";
import {Alarm} from "../../entities/Alarm";
import {NotificationService} from "../../services/NotificationService";
import {GridBookmarkService} from "../../services/GridBookmarkService";
import {AlarmAckService} from "../../services/AlarmAckService";

export class AlarmAckAdminPagingModel extends AdminPagingModel<Alarm>{
    static $inject = ['$q','AlarmAckService','NotificationService','GridBookmarkService'];
    constructor($q:ng.IQService, pagingService:AlarmAckService,notificationService:NotificationService,
                gridBookmarkService:GridBookmarkService){
        super($q, pagingService,notificationService,gridBookmarkService);
    }
    getCustomActions():string[]{
        return [];
    }
    entityName():string{
        return "alarmack";
    }
    displayName():string{
        return "Alarm Acks";
    }
    addEditAllowed():boolean{
        return false;
    }
    deleteAllowed():boolean{
        return true;
    }
    getColumnDefs():ng.IPromise<void>{
        this.nameValuePairs =
            [
                ['ackTime', 'Ack Time', 215],
                ['name', 'Name', 150],
                ['tag', 'Tag', 215],
                ['eventType', 'Event Type', 215],
                ['thresholdType', 'Threshold Type', 215],
                ['assetName', 'Asset Name', 215],
                ['assetDescription', 'Asset Description', 215]
            ];
        return this.$q.when();

    }
}
